import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';


const MyLoginIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path 
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        fill="currentColor"
      />
      <path 
        d="M13 7h-2v5.41l3.29 3.29 1.41-1.41-2.7-2.7V7z" 
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default MyLoginIcon;
